import { Injectable } from '@angular/core';
import {
    SquareRefundListItem,
    SquareRefundTotals,
} from '../store/square-refunds.models';

@Injectable({
    providedIn: 'root',
})
export class AdapterService {
    adaptAll(items: any[]): SquareRefundListItem[] {
        return items.map((item) => this.adaptSingle(item));
    }

    adaptSingle(data: any): SquareRefundListItem {
        return {
            id: data.id,
            squareReturnId: data.square_return_id ?? null,
            returnOrderId: data.return_order_id ?? null,
            sourceOrderId: data.source_order_id ?? null,
            refundType: data.refund_type ?? null,
            status: data.status,
            amount: data.amount,
            tax: data.tax,
            tip: data.tip,
            serviceCharge: data.service_charge,
            departure: data.departure ?? null,
            businessDate: data.business_date ?? null,
            expenseRegistered: data.expense_registered,
            processedAt: data.processed_at ?? null,
            locationName: data.location_name ?? null,
            locationId: data.location_id ?? null,
            playDate: data.play_date ?? null,
            createdAt: data.created_at,
        };
    }

    adaptTotals(data: any): SquareRefundTotals {
        return {
            totalAmount: data.total_amount,
            totalTax: data.total_tax,
            totalTip: data.total_tip,
            totalServiceCharge: data.total_service_charge,
        };
    }
}
